import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tableData: {},
  currentTableDataKey: "",
};

const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    setCurrentTableDataKey: (state, action) => {
      state.currentTableDataKey = action.payload;
    },
    setTableData: (state, action) => {
      const { tableDataKey, results } = action.payload?.data;
      state.tableData = {
        ...state.tableData,
        [tableDataKey]: results,
      };
    },
    updateTableData: (state, action) => {
      const { id, updatedData } = action.payload;
      const currentTableData = state.tableData[state.currentTableDataKey]?.results;
      console.log("updateTableData::", { currentTableData, id, updatedData });
      if (currentTableData) {
        const updatedResults = currentTableData.map((item) =>
          item.id === id ? updatedData : item,
        );
        console.log("updateTableData::", { updatedResults });
        state.tableData = {
          ...state.tableData,
          [state.currentTableDataKey]: {
            ...state.tableData[state.currentTableDataKey],
            results: updatedResults,
          },
        };
      } else {
        state.tableData = {
          ...state.tableData,
          [state.currentTableDataKey]: {
            ...state.tableData[state.currentTableDataKey],
            results: [updatedData],
          },
        };
      }
    },
    clearTableData: (state) => {
      state.tableData = {};
      state.currentTableDataKey = "";
    },
  },
});

export const { setTableData, updateTableData, setCurrentTableDataKey, clearTableData } =
  tableSlice.actions;
export default tableSlice.reducer;
